import { render, staticRenderFns } from "./ReportsEmailMigration.vue?vue&type=template&id=8237fade"
import script from "./ReportsEmailMigration.vue?vue&type=script&lang=js"
export * from "./ReportsEmailMigration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports